"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Price = function () {
  function Price() {
    _classCallCheck(this, Price);
  }

  _createClass(Price, [{
    key: "current",

    // TODO: v3: Default currency to usd, always call index.bitcoin.com
    value: async function current() {
      var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";

      try {
        if (currency === "all") {
          var _response = await _axios2.default.get("https://www.blocktrail.com/BCC/json/blockchain/price");
          return _response.data;
        }

        var response = await _axios2.default.get("https://index-api.bitcoin.com/api/v0/cash/price/" + currency);
        return response.data.price / 100.0;
      } catch (error) {
        if (error.response && error.response.data) throw error.response.data;else throw error;
      }
    }
  }]);

  return Price;
}();

exports.default = Price;